export default __webpack_public_path__ + "static/offering2-730178bd544bf4325c005e380508a83d.png";